import css from "./Edit.module.css"
const Edit = () => {
  return (
    <div className={css.Edit}>Edit</div>
  )
}

export default Edit